import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/** Footer links to the public Privacy Policy and Terms of Service. Shown on the
 *  auth pages so the policies are reachable from the app's entry points — Google
 *  OAuth verification expects the privacy policy to be linked from the app. */
export function LegalLinks() {
  const { t } = useTranslation();
  return (
    <p className="mt-8 text-center text-xs text-muted-foreground">
      <Link to="/privacy" className="hover:text-foreground hover:underline">
        {t('legal.privacy')}
      </Link>
      <span className="mx-2">·</span>
      <Link to="/terms" className="hover:text-foreground hover:underline">
        {t('legal.terms')}
      </Link>
    </p>
  );
}
